/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef } from 'react';
import { TextField, Avatar, CircularProgress, Paper } from '@material-ui/core/';
import './roomspage.css';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { createRoom } from '@/app/services/rooms/rooms';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { getImageUrl, isImageFile } from '@/utils/utils';
import PageHeader from '@/app/customComponents/PageHeader';
import { useNavigate } from 'react-router-dom';

const AddLocation = () => {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const [form, setForm] = useState({});
	const [errTxts, setErrTxts] = useState({});
	const [isAdding, setIsAdding] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [preview, setPreview] = useState();
	const inputRef = useRef(null);
	const navigate = useNavigate();

	useEffect(() => {
		if (!selectedFile) {
			setPreview(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		const file = e.target.files[0];
		if (!isImageFile(file)) {
			dispatch(Actions.showMessage({ message: 'Please select an image file', variant: 'error' }));
		} else {
			setSelectedFile(e.target.files[0]);
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [name]: '' });
		setForm({ ...form, [name]: value });
	};

	const handleSubmit = () => {
		setErrTxts({});
		if (!form.name) {
			setErrTxts({ ...errTxts, name: 'This field is required' });
			return;
		}
		if (
			(form.name && form.name.indexOf(' ') === 0) ||
			form.name.lastIndexOf(' ') === form.name.length - 1 ||
			/[^a-zA-Z ]/.test(form.name)
		) {
			setErrTxts({ ...errTxts, name: 'Please enter a valid name.' });
			return;
		}

		form.school_id = user.school?.id || user.data?.school?.id;
		form.room_type = 'place';
		if (selectedFile) {
			const filename = getImageUrl(selectedFile);
			setIsAdding(true);
			uploadFile(selectedFile, filename)
				.then((response) => {
					// form.photo = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					form.name = form.name.trim();
					form.thumb = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					createRoom(form)
						.then((resp) => {
							dispatch(
								Actions.showMessage({
									message: resp.data.message,
									autoHideDuration: 1500,
									variant: 'success',
								})
							);
							navigate(-1);
						})
						.catch((err) => {
							if (err.response?.data?.errors) {
								setErrTxts(err.response.data.errors);
							} else {
								dispatch(
									Actions.showMessage({
										message: 'Failed to add Room.',
										autoHideDuration: 1500,
										variant: 'error',
									})
								);
							}
						})
						.finally(() => setIsAdding(false));
				})
				.catch(() => {
					dispatch(
						Actions.showMessage({
							message: 'Failed to upload image.',
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
					setIsAdding(false);
				});
		} else {
			setIsAdding(true);
			form.name = form.name.trim();
			form.thumb = `${import.meta.env.VITE_S3_BASE_URL}${'public/images/front/2021-12-23_12_02_58_room.jpeg'}`;
			createRoom(form)
				.then((resp) => {
					dispatch(
						Actions.showMessage({
							message: resp.data.message,
							autoHideDuration: 1500,
							variant: 'success',
						})
					);
					navigate(-1);
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to add room.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					}
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to add room.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					}
				})
				.finally(() => setIsAdding(false));
		}
	};
	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<div className="mt-16 md:mt-32 w-11/12 mx-auto overflow-hidden max-w-3xl flex flex-col gap-32">
			<PageHeader onBack={handleGoBack} title="Add Location" />
			<Paper className="p-32 sm:p-32 flex flex-col gap-32">
				<h2 className="" style={{ color: '#06071D', fontWeight: '700', fontSize: '18px' }}>
					Location Information
				</h2>
				<div className=" flex flex-col justify-center sm:justify-start sm:flex-row sm:items-center gap-32">
					<div>
						<div
							className="relative pic-upload-overlay cursor-pointer"
							id="upload-room-img"
							onClick={() => inputRef.current.click()}
						>
							<Avatar src={preview} style={{ height: '120px', width: '120px' }} />
							<div className="pp-input-overlay ">
								<i className="fa fa-2x fa-camera" />
							</div>
							<input
								accept="image/*"
								className="hidden"
								id="image"
								name="image"
								onChange={onSelectFile}
								ref={inputRef}
								type="file"
							/>
						</div>
					</div>
					<div className="w-full flex flex-col gap-32" style={{ fontWeight: 'normal' }}>
						<TextField
							error={!!errTxts.name}
							fullWidth
							helperText={errTxts.name}
							id="room"
							label="Location Name"
							name="name"
							onChange={handleChange}
							required
						/>
					</div>
				</div>

				{isAdding ? (
					<div className="flex justify-center my-24">
						<CircularProgress className="mx-auto" />
					</div>
				) : (
					<div className="flex justify-center w-max my-24" style={{ gap: '20px' }}>
						<CustomButton
							fontSize="15px"
							height="55"
							id="cancel"
							onClick={() => {
								navigate(-1);
							}}
							variant="secondary"
							width="140px"
						>
							Cancel
						</CustomButton>

						<CustomButton
							fontSize="15px"
							height="55"
							id="add-room"
							onClick={() => {
								handleSubmit();
							}}
							variant="primary"
							width="140px"
						>
							Submit
						</CustomButton>
					</div>
				)}
			</Paper>
		</div>
	);
};

export default AddLocation;
